import { render, staticRenderFns } from "./SendFaxModal.vue?vue&type=template&id=bccac040&scoped=true"
import script from "./SendFaxModal.vue?vue&type=script&lang=js"
export * from "./SendFaxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccac040",
  null
  
)

export default component.exports